import { createContext, useContext } from "react";

// Permite abrir, desde cualquier detalle de factura, el visor de consulta (solo lectura) de otra factura relacionada
// (original, rectificativa, anulación, complementaria, parciales). Fuera del proveedor no hace nada.
export interface IVisorFactura {
  abrir: (facturaId: string) => void;
}

export const VisorFacturaContext = createContext<IVisorFactura>({ abrir: () => {} });

export const useVisorFactura = () => useContext(VisorFacturaContext);
